module.exports = {
  "name": "printemps-nation",
  "client": "Printemps Nation",
  "codifName": "M445",
  "validLangs": ["en", "fr", "zh"],
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "12.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 33,
    "androidCompileSdkVersion": 33,
    "androidSigning": {
      "keyAlias": "Printemps-Nation",
      "keyStorePassword": "ohCee8too7raifee"
    },
    "app": "app-react",
    "appleTeamId": "2BAP3P29V2",
    "name": {
      "default": "Printemps   Nation_D"
    },
    "id": "com.printemps.nation.dev",
    "appleAppId": "1605952143"
  },
  "cordova": true,
  "crypto": false,
  "customFileUrlScheme": "msfile",
  "geoGroup": {},
  "web": {
    "url": "nation.ms-dev.mobile-spot.com"
  },
  "version": {
    "mainVersion": "1.0.0",
    "buildVersion": {
      "iOS": "6",
      "android": "6",
      "web": "5"
    }
  },
  "relatedRepos": [{
    "src": "git@bitbucket.org:mobilespotdev/cordova.git",
    "postCommands": ["cd cordova && npm install"],
    "branch": "inte/printemps-nation/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo.git",
    "postCommands": ["cd mobigeo && npm install"],
    "branch": "inte/printemps-nation/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo-customs-master.git",
    "dest": "mobigeo/mobigeo-customs",
    "branch": "inte/printemps-nation/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/app-react.git",
    "branch": "inte/printemps-nation/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/data-master.git",
    "dest": "app-react/app-customs",
    "branch": "inte/printemps-nation/main",
    "postCommands": ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
};